<script setup>

import { inject, ref } from 'vue';
import { apiSourcerJeuDonnees } from '@/services/ServiceModele.js';
import Dialog from 'primevue/dialog';
import JeuDonnees from '@/components/generiques/JeuDonnees.vue';
import SelecteurJeuDonnees from '@/components/generiques/SelecteurJeuDonnees.vue';

const { jeuDonnees, typeSource, campagnes } = defineProps({
    jeuDonnees: Object,
    typeSource: String,
    campagnes: Array
});

const visible = defineModel('visible', {
    type: Boolean
});

const emit = defineEmits(['fermeture']);

const appelerApiModifModele = inject('appelerApiModifModele');
const afficherSucces = inject('afficherSucces');

const jeuSelectionne = ref(null);

function getTitreModale() {
    switch(typeSource) {
        case 'DERIVATION':
            return 'Dérivation à partir d\'un autre jeu de données';
        case 'DUPLICATION':
            return 'Duplication d\'un autre jeu de données';
    }
}

function valider() {
    appelerApiModifModele(apiSourcerJeuDonnees, typeSource, jeuSelectionne.value, (reponseOK) => {
        if (reponseOK) {
            emit('fermeture', true);
            afficherSucces('Sourcing effectué');
        }
    });
}

</script>

<template>
    <Dialog 
        v-model:visible="visible" 
        modal 
        :header="getTitreModale()">
            <div class="texte-introductif">
                <label class="intitule">Jeu :</label>
                <JeuDonnees 
                    :jeu-donnees="jeuDonnees"/>
            </div>
            <label class="intitule">Jeu source :</label>
            <SelecteurJeuDonnees 
                v-model:selection="jeuSelectionne"
                :campagne-par-defaut="jeuDonnees.campagne"
                :noms-campagnes="campagnes"
                :selection-multiple="false"
                :est-jeu-desactive="jeu => jeu.statut === 'INITIAL'" />
            <template #footer>
                <button 
                    class="bouton btn-primaire fas fa-check" 
                    :disabled="jeuSelectionne == null"
                    @click="valider()"/>
            </template>
    </Dialog>
</template>

<style scoped>

.texte-introductif {
    margin-top: 2px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 20px;
}

.selecteur-jeu-donnees {
    border: 1px solid var(--couleur-bordure);
    border-radius: 5px;
    padding: 20px;
}

</style>